package pwgs.ui.scenes.remoteconfigscene

import pwgs.ui.scenes.custompropertieseditorscene.CustomPropertiesEditorScene
import pwgs.ui.scenes.custompropertieseditorscene.CustomPropertiesEditorSceneProps
import visage.core.Components
import visage.ds.components.page.Page

fun Components.RemoteConfigScene(projectId: Long) = this.registerFunctionalComponent({}) {
    Page {
        head("Remote config")

        body {
            CustomPropertiesEditorScene(CustomPropertiesEditorSceneProps(projectId, "RemoteConfig"))
        }
    }
}